import { TrendingUp } from 'lucide-react';

export const NudgeBanner = ({ nudge, unit, current, target, onUse }) => (
  <div className="mb-3 rounded-2xl border border-primary/40 bg-primary/10 p-3 flex items-center gap-3" data-testid="setlogger-nudge">
    <TrendingUp className="h-5 w-5 text-primary shrink-0" />
    <p className="flex-1 text-xs text-white/80 leading-snug">
      {nudge.sessions} sessions of {nudge.target_sets} × {nudge.target_reps} at {current} {unit}.
      Try <b className="text-primary">{target} {unit}</b> today.
    </p>
    <button
      type="button" onClick={onUse}
      className="shrink-0 px-3 h-9 rounded-full bg-primary text-black text-xs font-bold active:scale-95 transition-transform"
      data-testid="setlogger-nudge-use"
    >
      Use {target} {unit}
    </button>
  </div>
);

export const AutoRestToggle = ({ on, onToggle }) => (
  <button
    type="button" onClick={onToggle}
    className="mt-3 inline-flex items-center gap-2 text-[11px] text-white/50 hover:text-white"
    data-testid="setlogger-autorest-toggle"
    aria-pressed={on}
  >
    <span className={`h-4 w-7 rounded-full relative transition-colors ${on ? 'bg-primary' : 'bg-white/20'}`}>
      <span className={`absolute top-0.5 h-3 w-3 rounded-full bg-black transition-[left] ${on ? 'left-3.5' : 'left-0.5'}`} />
    </span>
    Auto rest {on ? 'on' : 'off'}
  </button>
);
